module.exports = __webpack_public_path__ + "img/steve-jobs.407d5d69.jpg";